const MV_DEFAULT_COLOR = '#41a4a9'
const TAG_BTN_PLACEMENT = 240
const TAG_BTN_BUFFER = `${window.innerHeight - TAG_BTN_PLACEMENT}px`

/**
 * Helper function to determine if button text should be white
 * or black, based upon the value of "custom_cmp_color" from the model
 * Adapted from https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/
 */

/* eslint-disable no-magic-numbers */
function colorHelper(hexcolor: string) {
  let color: string
  // remove the leading '#' character
  color = hexcolor.slice(1)
  // handle hexcode color shorthand (e.g., #eee)
  color = color.length > 3 ? color : color + color
  const r = parseInt(color.substr(0, 2), 16)
  const g = parseInt(color.substr(2, 2), 16)
  const b = parseInt(color.substr(4, 2), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? '#000' : '#fff'
}
/* eslint-enable no-magic-numbers */

const css = (custom_cmp_color: string): string => `
  .mediavine-ccpa {
    font-size: 14px;
    font-family:
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      Helvetica,
      Arial,
      sans-serif;
  }

  .mediavine-ccpa-btn {
    display: block;
    width: initial;
    height: initial;
    z-index: 2147483647;
    padding: 0;
    padding-right: 8px;
    padding-left: 8px;
    margin: 0;
    text-align: center;
    text-decoration: none;
    text-transform: none;
    letter-spacing: initial;
    line-height: initial;
    border-radius: 0;
    box-shadow: none;
    transition: none;
  }

  .mediavine-ccpa-btn:active,
  .mediavine-ccpa-btn:focus,
  .mediavine-ccpa-btn:focus-within,
  .mediavine-ccpa-btn:hover {
    background: initial;
  }

  .mediavine-ccpa-tag-btn {
    position: absolute;
    left: -93px;
    top: ${TAG_BTN_BUFFER};
    min-width: 218px;
    min-height: 34px;
    font-weight: 500;
    font-size: 12px;
    color: #fff;
    background: #919191;
    border: none;
    transform: rotate(-90deg);
  }

  @media(max-width: 767px) {
    .mediavine-ccpa-tag-btn {
      left: -101px;
      min-height: 20px;
    }
  }

  .mediavine-ccpa-tag-btn:active,
  .mediavine-ccpa-tag-btn:focus,
  .mediavine-ccpa-tag-btn:focus-within,
  .mediavine-ccpa-tag-btn:hover {
    background: #919191;
  }

  .mediavine-ccpa-modal-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom:0;
    left: 0;
    z-index: 2147483647;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: auto;
    background:rgba(0,0,0,.8);
    animation: opacity .2s ease 1;
  }

  .mediavine-ccpa-modal-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 36px;
    max-width: 600px;
    min-height: 450px;
    height: auto;
    color: #1e1e1e;
    background: #fafafa;
    border-radius: 5px;
    border-top: 10px solid ${custom_cmp_color || MV_DEFAULT_COLOR};
    animation: fadeUp .3s ease 1;  
  }

  .mediavine-ccpa-modal-close {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 42px;
    height: 42px;
    padding: 0;
    margin: 4px;
    background: none;
    border: none;
  }

  .mediavine-ccpa-modal-close::after {
    content: " \\d7";
    display: inline;
    font-size: 50px;
    font-weight: 300;
    line-height: 24px;
    color: #1e1e1e;
  }

  .mediavine-ccpa-modal-body {
    padding: 18px;
    height: 100%;
  }

  .mediavine-ccpa-modal-body p {
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
    font-family:
      -apple-system,
      BlinkMacSystemFont,
      'Segoe UI',
      Roboto,
      Helvetica,
      Arial,
      sans-serif;
    font-size: initial;
    font-style: inherit;
    line-height: normal;
    letter-spacing: normal;
    -webkit-font-smoothing: always;
  }

  .mediavine-ccpa-modal-heading-container {
    padding-bottom: 20px;
    margin-right: auto;
    margin-left: auto;
    max-width: 80%;
  }

  .mediavine-ccpa-modal-heading-container p {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    text-align: center;
  }

  .mediavine-ccpa-modal-text-container {
    padding-right: 20px;
    margin-top: 10px;
    margin-right: 20px;
    margin-bottom: 10px;
    margin-left: 20px;
    height: 260px;
    overflow-x: auto;
  }

  .mediavine-ccpa-modal-text-container p,
  .mediavine-ccpa-modal-text-container label {
    font-size: 16px;
    font-weight: 300;
    line-height: 26px;
  }

  .mediavine-ccpa-modal-optout-link {
    letter-spacing: initial;
    text-transform: none;
    text-decoration: inherit;
    cursor: pointer;
  }

  .mediavine-ccpa-modal-optout-link:hover {
    text-decoration: inherit;
  }

  .mediavine-ccpa-modal-optout-checkbox,
  input[type=checkbox] {
    padding: initial;
    margin: initial;
    border: 1px solid #e1e1e1;
    -moz-appearance: none;
	  -webkit-appearance: none;
    appearance: none;
    background: none;
    cursor: pointer;
  }

  .mediavine-ccpa-modal-optout-checkbox,
  input[type=checkbox]:checked {
    background: ${custom_cmp_color || MV_DEFAULT_COLOR};
    transition: .2s ease;
  }

  .mediavine-ccpa-modal-optout-checkbox,
  input[type=checkbox] {
    margin-left: 4px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
  }

  .mediavine-ccpa-modal-optout-checkbox,
  input[type=checkbox]::before {
    padding-top: 0;
    padding-right: 0;
    padding-bottom: 0;
    padding-left: 4px;
    content: '';
    font-size: 18px;
  }

  .mediavine-ccpa-modal-optout-checkbox,
  input[type=checkbox]:checked::before {
    content: '\\2713';
    color: ${
      custom_cmp_color && custom_cmp_color.toLowerCase() !== MV_DEFAULT_COLOR
        ? colorHelper(custom_cmp_color)
        : '#fff'
    };
  }

  .mediavine-ccpa-modal-btn-container {
    padding-top: 20px;
    text-align: center;
  }

  .mediavine-ccpa-modal-btn {
    width: 50%;
    height: 36px;
    margin-right: auto;
    margin-left: auto;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    color: ${
      custom_cmp_color && custom_cmp_color.toLowerCase() !== MV_DEFAULT_COLOR
        ? colorHelper(custom_cmp_color)
        : '#fff'
    };
    background: ${custom_cmp_color || MV_DEFAULT_COLOR};
    border: none;
    border-radius: 18px;
    cursor: pointer; 
  }

  .mediavine-ccpa-modal-btn:active,
  .mediavine-ccpa-modal-btn:focus,
  .mediavine-ccpa-modal-btn:focus-within,
  .mediavine-ccpa-modal-btn:hover {
    background: ${custom_cmp_color || MV_DEFAULT_COLOR};
  }

  @keyframes opacity {
    from { opacity: 0 };
    to { opacity: 1 };
  }

  @keyframes fadeUp {
    from { transform: translateY(100%); opacity: 0 };
    to { transform: translateY(0); opacity: 1 };
  }
`

export { css }
